<template>
    <div class="space--md space-bottom--md">
        <div class="container">
            <div class="row" >
                <div class="col-xs-12 col-sm-12 col-xl-12">
                    <h3 class="space-bottom--md" v-if="data.showTitle">{{data.title}}</h3>
                    <div v-html="data.content"></div>

                    <accordion>
                        <accordion-item :key="index" v-for="(item, index) in data.items">
                            <template v-slot:accordion-title slot="accordion-title">
                                <div class="medium h4">{{item.title}}</div>
                            </template>
                            <template v-slot:accordion-content slot="accordion-content">
                                <div v-html="item.content"></div>
                            </template>
                        </accordion-item>
                    </accordion>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Accordion from "../Accordions/Accordion";
    import AccordionItem from "../Accordions/AccordionItem";

    export default {
        name: "element-accordion",
        components: {
            Accordion,
            AccordionItem
        },
        props: {
            data: {
                type: Object
            }
        },
        data () {
            return {
                
            }
        },
    };
</script>

<style lang="scss" scoped>

</style>
